<div fxLayout="column" style="padding-top: 12px;">
    <form [formGroup]="firstFormGroup">
        <div *ngIf="data.enablePickDate==1" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
            <mat-form-field fxFlex="50" appearance="outline" fxLayoutGap="10px">
                <mat-label>{{data.pickDateText}}</mat-label>
                <input [min]="today" [matDatepicker]="todayDate" formControlName="pickUp" matInput>
                <mat-datepicker-toggle [for]="todayDate" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #todayDate></mat-datepicker>
            </mat-form-field>
        </div>

        <div *ngIf="data.enableMessageDetailPage==1" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
            <mat-form-field appearance="outline" fxFlex>
                <mat-label>{{data.messageText}}</mat-label>
                <textarea   [required]="messageRequired==1" trim="blur" rows="3" cols="50" matInput formControlName="additionalMessgae" matInput>
            </textarea> 
            <mat-error *ngIf="firstFormGroup.controls.additionalMessgae.errors?.required">
                Please fill out this field.
               </mat-error>
            </mat-form-field>
        </div>
    </form>
</div>